import { Switch } from 'antd'
import configuration from 'modules/configuration'
import login from 'modules/login'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'

const getInitialTheme = (theme) => {
  // Verifica localStorage o el tema del sistema
  // const saved = localStorage.getItem('theme')
  if (theme) return theme
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) return 'dark'
  return 'light'
}

const ThemeToggle = ({ loggedUser, editProfile, whoAmI }) => {
  const [theme, setTheme] = useState(getInitialTheme(loggedUser.theme))

  useEffect(() => {
    document.body.classList.remove('LIGHT', 'DARK')
    document.body.classList.add(theme)
  }, [theme])

  const toggleTheme = () => {
    const nuevoTema = theme === 'LIGHT' ? 'DARK' : 'LIGHT'
    editProfile(loggedUser.pkid, { theme: nuevoTema }).then(() => {
      whoAmI().then((response) => {
        setTheme(response.payload.data.theme)
        window.dispatchEvent(new Event('theme-changed'))
      })
    })
  }

  return (
    <Switch
      checkedChildren="Modo oscuro"
      unCheckedChildren="Modo claro"
      defaultChecked={loggedUser.theme === 'DARK'}
      onChange={toggleTheme}
    />
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
})

const mapDispatchToProps = {
  editProfile: configuration.actions.editProfile,
  whoAmI: login.actions.whoAmI,
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeToggle)
